// app/assets/javascripts/insured_shipping.js
export function isEUCountry(code) {
  if (!code) return false;
  const EU_COUNTRIES = [
    'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE',
    'IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'
  ];
  return EU_COUNTRIES.includes(code.toUpperCase());
}
